import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CaseService } from '@modules/cases/services/case.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-finish-page',
  templateUrl: './finish-page.component.html',
  styleUrls: ['./finish-page.component.scss']
})
export class FinishPageComponent implements OnInit {

  redirectURL = this.caseService.uploadCallbackUrl$.getValue();

  constructor(private router: Router, private caseService: CaseService, private translate: TranslateService) {
  }

  ngOnInit() {
    if(this.redirectURL)
    {
      setTimeout(() => {
        if(!this.redirectURL.includes("http")){
          window.location.href = "http://" + this.redirectURL;
        }
        else{
          window.location.href = this.redirectURL;
        }
      }, 2000);
    }
  }
}
